module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "view-switch"
  }, [_c('li', {
    staticClass: "view-item card",
    class: {
      'active': _vm.active === 'card'
    },
    attrs: {
      "title": "卡片视图"
    },
    on: {
      "click": function($event) {
        _vm.doSelect('card')
      }
    }
  }, [_c('a')]), _vm._v(" "), _c('li', {
    staticClass: "view-item list",
    class: {
      'active': _vm.active === 'list'
    },
    attrs: {
      "title": "列表视图"
    },
    on: {
      "click": function($event) {
        _vm.doSelect('list')
      }
    }
  }, [_c('a')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65d07291!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components-buy/ListContain/ListMain/CarNav/ViewSwitch.vue
// module id = 865
// module chunks = 5